import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@components/common/ProtectedRoute';
import { RoleGuard } from '@components/common/RoleGuard';
import { AppLayout } from '@components/layout/AppLayout';
import { LoginPage } from '@features/auth/components/LoginPage';
import { AzureCallbackPage } from '@features/auth/components/AzureCallbackPage';
import { ServiceUnavailablePage } from '@features/auth/components/ServiceUnavailablePage';
import { ForgotPasswordPage } from '@features/auth/components/ForgotPasswordPage';
import { ResetPasswordPage } from '@features/auth/components/ResetPasswordPage';
import { SetNewPasswordPage } from '@features/auth/components/SetNewPasswordPage';
import { CompanySelectorPage } from '@features/companies/components/CompanySelectorPage';
import { DashboardPage } from '@features/dashboard/components/DashboardPage';
import { InvoiceListPage } from '@features/invoices/components/InvoiceListPage';
import { InvoiceWizardPage } from '@features/invoices/components/InvoiceWizardPage';
import { InvoiceDetailPage } from '@features/invoices/components/InvoiceDetailPage';
import { CustomerListPage } from '@features/customers/components/CustomerListPage';
import { ProductListPage } from '@features/products/components/ProductListPage';
import { EditCompanyPage } from '@features/company/components/EditCompanyPage';
import { AdminSettingsPage } from '@features/company/components/AdminSettingsPage';
import { BranchOfficeManagerPage } from '@features/branchOffice/components/BranchOfficeManagerPage';
import { UserManagerPage } from '@features/users/components/UserManagerPage';
import { MainPage } from '@features/home/components/MainPage';
import { MinorPage } from '@features/home/components/MinorPage';
import { ReportsPage } from '@features/reports/components/ReportsPage';
// SUBSCRIPTIONS_DISABLED: import { PlansPage } from '@features/subscriptions/components/PlansPage';
import { FAQPage } from '@features/faq';
import { UserManualPage } from '@features/manual';
import { DevToolsPage } from '@features/devtools/components/DevToolsPage';
import { BannerAdminPage } from '@features/announcements/components/BannerAdminPage';


export function AppRoutes() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      {/* Dos rutas para el mismo componente: la Redirect URI registrada en el
          Azure Portal de cada cliente varía y no la administramos nosotros.
          /auth/azure/callback es la nueva por default; /signin-oidc es la que
          ya tenían registrada en producción los tenants que vienen del portal
          ASP.NET legacy (Microsoft.Identity.Web). Cuál usa cada tenant se
          decide en AZURE_AD_TENANTS.<id>.callbackPath (backend) — ver
          azureAd.ts. */}
      <Route path="/auth/azure/callback" element={<AzureCallbackPage />} />
      <Route path="/signin-oidc" element={<AzureCallbackPage />} />
      <Route path="/service-unavailable" element={<ServiceUnavailablePage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/set-password/:userId/:tenantId/:token" element={<SetNewPasswordPage />} />

      {/* Protected routes */}
      <Route element={<ProtectedRoute />}>
        {/* Company Selection - outside AppLayout */}
        <Route path="/select-company" element={<CompanySelectorPage />} />

        <Route element={<AppLayout />}>
          <Route element={<RoleGuard />}>
            <Route path="/home/main" element={<MainPage />} />
            <Route path="/home/minor" element={<MinorPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/invoices" element={<InvoiceListPage />} />
            <Route path="/invoices/new" element={<InvoiceWizardPage />} />
            <Route path="/pages/invoice/:id" element={<InvoiceDetailPage />} />
            <Route path="/customers" element={<CustomerListPage />} />
            <Route path="/products" element={<ProductListPage />} />

            {/* Company Routes */}
            <Route path="/company/edit" element={<EditCompanyPage />} />
            <Route path="/company/settings" element={<AdminSettingsPage />} />

            {/* Branch Office Routes */}
            <Route path="/branchoffice/manager" element={<BranchOfficeManagerPage />} />

            {/* User Routes */}
            <Route path="/user/manager" element={<UserManagerPage />} />

            {/* Admin Routes */}
            <Route path="/admin/devtools" element={<DevToolsPage />} />
            <Route path="/admin/banners" element={<BannerAdminPage />} />

            {/* Report Routes */}
            <Route path="/report/reports" element={<ReportsPage />} />

            {/* SUBSCRIPTIONS_DISABLED
            <Route path="/subscriptions/plans" element={<PlansPage />} />
            */}

            {/* FAQ Routes */}
            <Route path="/faq" element={<FAQPage />} />

            {/* Manual Routes */}
            <Route path="/manual" element={<UserManualPage />} />

            {/* Redirect root to home */}
            <Route path="/" element={<Navigate to="/home/main" replace />} />
          </Route>
        </Route>
      </Route>

      {/* Catch all - redirect to login */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
